import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener('DOMContentLoaded', () => {
  const sliderElements = document.querySelectorAll('.js-splide');

  sliderElements.forEach((el) => {
    // 安全策：trackとlistが存在するかチェック
    if (!el.querySelector('.splide__track') || !el.querySelector('.splide__list')) {
      return;
    }

    // --- 1. 全スライダー共通のデフォルト設定 ---
    let options = {
      type: 'loop',
      speed: 1500,
      autoplay: true,
      interval: 4000,
      pauseOnHover: false,
      arrows: true,     // 基本は出す
      pagination: true, // 基本は出す
    };

    // --- 2. 各クラスごとの個別上書き設定 ---

    // フェードタイプ（MV系・コンセプト・施設MV）
    if (
      el.classList.contains('is-mv') ||
      el.classList.contains('is-banquet-mv') ||
      el.classList.contains('is-facility-mv') ||
      el.classList.contains('is-conept-closing') ||
      el.classList.contains('is-dress-mv') ||
      el.classList.contains('is-cuisine-mv') ||
      el.classList.contains('is-top-ceremony')
    ) {
      options = {
        ...options,
        type: 'fade',
        rewind: true,
        arrows: false,
        pagination: false,
        easing: 'linear',
      };
    }

    // ウェディングフェア・プラン（PC:左寄せ、SP:中央寄せ）
    if (el.classList.contains('is-weddingfair') || el.classList.contains('is-weddingplan')) {
      options = {
        ...options,
        autoWidth: true,
        focus: 0,
        gap: '28px',
        pagination: false,
        breakpoints: {
          1000: {
            focus: 'center',
          },
        },
      };
    }

    // TOPICS（TOPページ）
    // PCのみ3件表示のカルーセル（1件ずつスライド）。SPは縦積み（destroy）。
    // 3件以下の場合は index.php 側で js-splide を付けないのでスライドしない。
    if (el.classList.contains('is-topics')) {
      options = {
        ...options,
        perPage: 3,
        perMove: 1,
        gap: '12px',
        speed: 800,
        pagination: false,
        breakpoints: {
          1000: {
            destroy: true,
          },
        },
      };
    }

    // バンケット・挙式・施設（標準ループ・ドットあり）
    if (el.classList.contains('is-banquet') || el.classList.contains('is-ceremony') || el.classList.contains('is-facility') || el.classList.contains('is-cuisine-course') || el.classList.contains('is-cuisine-ordermade')) {
      options = {
        ...options,
        autoWidth: true,
        focus: 0,
        gap: '5px',
        perPage: 1,
      };
    }

    // 料理（SP:フェード、PC:静止・destroy）
    if (el.classList.contains('is-cuisine')) {
      options = {
        ...options,
        destroy: true,
        type: 'fade',
        rewind: true,
        arrows: false,
        pagination: false,
        breakpoints: {
          1000: {
            destroy: false,
          },
        },
      };
    }

    // 施設紹介（SP:左寄せ、PC:静止・destroy）
    if (el.classList.contains('is-facility-thumbnail')) {
      options = {
        ...options,
        destroy: true,
        gap: '4px',
        rewind: true,
        arrows: true,
        pagination: false,
        focus: 0,
        breakpoints: {
          1000: {
            destroy: false,
            gap: '20px',
          },
        },
      };
    }

    // その他（中央寄せ）
    if (el.classList.contains('is-other')) {
      options = {
        ...options,
        autoWidth: true,
        focus: 'center',
        gap: '0px',
      };
    }

    // ウェディングレポート（止まらないループ：AutoScroll）
    if (el.classList.contains('is-weddingreport')) {
      options = {
        ...options,
        type: 'loop',
        drag: 'free',
        focus: 'center',
        autoWidth: true,
        arrows: false,
        pagination: false, // スペルミス修正済み
        autoplay: false,   // AutoScroll使用時はautoplayをOFFにする
        autoScroll: {
          speed: 0.5,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      };
    }

    // その他コンテンツ
    if (el.classList.contains('is-othercontents')) {
      options = {
        ...options,
        autoWidth: true,
        focus: 0,
        gap: '33px',
        pagination: false,
        breakpoints: {
          1000: {
            gap: '20px',
          },
        },
      };
    }

    // パーティープレイスMV・アフターセレモニー
    if (el.classList.contains('is-partyplace-mv') || el.classList.contains('is-afterceremony')) {
      options = {
        ...options,
        autoWidth: true,
        focus: 0,
        gap: '4px',
        breakpoints: {
          1000: {
            arrows: false,
            gap: '0px',
          },
        },
      };
    }

    // その他バンケット（PC:静止、SP:スライド）
    if (el.classList.contains('is-otherbanquet')) {
      options = {
        ...options,
        autoWidth: true,
        focus: 0,
        gap: '20px',
        pagination: false,
        autoplay: false,
        destroy: true, // デフォルト（PC）は破壊
        breakpoints: {
          1000: {
            destroy: false, // 1000px以下で有効化
            autoplay: true,
          },
        },
      };
    }

    //ドレス
    if (el.classList.contains('is-dress')) {
      options = {
        ...options,
        autoWidth: true,
        focus: 0,
        gap: '4px',
      };
    }

    //その他アイテム
    if (el.classList.contains('is-weddingaccessory')) {
      options = {
        ...options,
        autoWidth: true,
        focus: 0,
        arrows: false,
        gap: '25px',
        breakpoints: {
          1000: {
            gap: '4px',
          },
        },
      };
    }

    if (el.classList.contains('is-weddingitem')) {
      options = {
        ...options,
        autoWidth: true,
        focus: 0,
        arrows: false,
        gap: '25px',
        breakpoints: {
          1000: {
            gap: '4px',
            arrows: true,
          },
        },
      };
    }

    // 施設紹介（SP:左寄せ、PC:静止・destroy）
    if (el.classList.contains('is-cuisine-option')) {
      options = {
        ...options,
        destroy: true,
        autoWidth: true,
        gap: '4px',
        rewind: true,
        arrows: true,
        pagination: true,
        focus: 0,
        breakpoints: {
          1000: {
            destroy: false,
          },
        },
      };
    }

    if (el.classList.contains('is-photowedding-feature')) {
      options = {
        ...options,
        autoWidth: true,
        gap: '6px',
        rewind: true,
        arrows: true,
        pagination: true,
        focus: 'center',

      };
    }

    if (el.classList.contains('is-photowedding-schedule')) {
      options = {
        ...options,
        autoWidth: true,
        gap: '30px',
        rewind: true,
        arrows: false,
        pagination: true,
        focus: 0,
        breakpoints: {
          1000: {
            gap: '4px',
            arrows: true,
          },
        },
      };
    }

    // --- 3. インスタンス化とマウント ---
    const splide = new Splide(el, options);

    // AutoScrollを使用する可能性があるスライダーに拡張機能を渡す
    splide.mount(el.classList.contains('is-weddingreport') ? { AutoScroll } : {});
  });
});
